import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, mappingResultError, Result, UseCase } from '@digibricks/domains';
export var UPDATE_MATCHING_CORRECT_ANSWER_USE_CASE = 'UPDATE_MATCHING_CORRECT_ANSWER_USE_CASE';
export var UpdateMatchingCorrectAnswerUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateMatchingCorrectAnswerUseCase, _UseCase);

  var _super = _createSuper(UpdateMatchingCorrectAnswerUseCase);

  function UpdateMatchingCorrectAnswerUseCase() {
    _classCallCheck(this, UpdateMatchingCorrectAnswerUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(UpdateMatchingCorrectAnswerUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var currentQuestion, data, id, answerId, score, question, correctAnswer, updatedResult, _updatedResult, totalScore;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentQuestion = input.currentQuestion, data = input.data;
                id = data.id, answerId = data.answerId, score = data.score;
                question = currentQuestion;
                correctAnswer = question.correctAnswers.find(function (correctAnswerId) {
                  return correctAnswerId.id.toString() === id;
                });

                if (correctAnswer) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", new BadInputError('Correct Answer does not exist '));

              case 6:
                if (!answerId) {
                  _context.next = 11;
                  break;
                }

                updatedResult = correctAnswer.updateAnswerId(answerId);

                if (!updatedResult.isFailure) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", mappingResultError(updatedResult));

              case 10:
                question.updateCorrectAnswer(correctAnswer);

              case 11:
                if (!(score >= 0)) {
                  _context.next = 16;
                  break;
                }

                _updatedResult = correctAnswer.updateScore(score);

                if (!_updatedResult.isFailure) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", mappingResultError(_updatedResult));

              case 15:
                question.updateCorrectAnswer(correctAnswer);

              case 16:
                totalScore = question.correctAnswers.reduce(function (a, b) {
                  return a + b.score;
                }, 0);
                question.updateScore(totalScore);
                return _context.abrupt("return", Result.ok(question));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return UpdateMatchingCorrectAnswerUseCase;
}(UseCase);